import { Component, effect, inject, Signal, ChangeDetectionStrategy } from '@angular/core';
import { UserPreferences } from '@iot-platform/models/common';
import { PreferencesFacade, UserProfileService } from '@iot-platform/data-access/users';

@Component({
  selector: 'oyan-app-root',
  template: `
    <router-outlet />
    <iot-platform-notification />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {
  protected readonly preferencesFacade: PreferencesFacade = inject(PreferencesFacade);
  protected readonly userProfileService: UserProfileService = inject(UserProfileService);
  private preferences: Signal<UserPreferences> = this.preferencesFacade.preferences;

  constructor() {
    effect(() => {
      const preferences = this.preferences();
      if (preferences) {
        this.userProfileService.setThemeOverlay();
        this.preferencesFacade.setLanguage(preferences.appLanguage);
      }
    });
  }
}
